<template>
  <BaseModal
    name="BackBalanceClientsModal"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="beforeClose"
    :adaptive="true"
    height="auto"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('BackBalanceClientsModal')"
      ></button>

      <div class="tw-text-center">
        <div class="tw-app-modal__title">
          {{ dataLang["clients_register_text_200"] }}
        </div>

        <div class="tw-mb-[15px]">
          {{ dataLang["clients_register_text_199"] }}
        </div>

        <div class="tw-mb-[15px]" ref="amount">
          <div class="tw-app-input-type-3-label">
            {{ dataLang["clients_register_text_140"] }}
          </div>
          <BaseInputNew
            :forFinanceType="true"
            inputRef="amount__3"
            inputClass="tw-app-input-type-3"
            input-name="amount"
            @input="
              (data) => updateValue({ value: data.value, name: data.name })
            "
            :horizontalTitle="true"
            :value="dataForEmit.amount"
          >
          </BaseInputNew>
        </div>

        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            @click="$modal.hide('BackBalanceClientsModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["clients_register_text_142"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["clients_register_text_143"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ObjectService from "@/api/ObjectsService.js";
import BidsService from "@/api/BidsService";
import EventBus from "@/event-bus.js";
import GeneralService from "@/api/GeneralService";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {},
  props: {
    stateLoading: {
      type: Boolean,
      default: false,
    },
    optionalParams: {
      type: Object,
    },
  },
  data() {
    return {
      listOptions: [],
      finreestr_funds__id: [],
      dataForEmit: {
        amount: null,
        type: "managerBack",
      },

      //       {
      //    "request_services__type_service_id": 1,
      //    "vehicleId":128,
      //    "date":"2020-05-05",
      //    "ownerId":1,
      //    "city":"Орехово",
      //    "nolimit":true,
      //    “comment”: “текст”
      // }
    };
  },
  methods: {
    setSelected(data) {
      this.dataForEmit.finreestr_funds__id = data.finreestr_funds__id;
      this.$refs.finreestr_funds__id.classList.remove("input-error");
    },
    beforeClose(event) {
      // this.dataForEmit.vehicle_comments__text = null
      // this.dataForEmit.vehicle_comments__is_critical = null
      // this.selectLabel = ''
      this.dataForEmit = {
        amount: null,
        type: "managerBack",
      };
      Object.keys(this.dataForEmit).forEach((elem, index) => {
        if (this.$refs[elem]) {
          this.$refs[elem].classList.remove("input-error");
        }
      });
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      this.$refs[data.name].classList.remove("input-error");
    },

    sendData() {
      GeneralService.editOrCreate(
        `/clients/${this.optionalParams.id.id}/balance`,
        this.dataForEmit
      )
        .then((data) => {
          this.$toast.success("Запись добавлена");
          Object.keys(this.dataForEmit).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.remove("input-error");
            }
          });
          EventBus.$emit("contentLoaded");
          EventBus.$emit("updateContentData");
          this.dataForEmit = {
            amount: null,
            type: "managerBack",
          };
          this.$modal.hide("BackBalanceClientsModal");
        })
        .catch((err) => {
          Object.keys(err.response.data.errors).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.add("input-error");
            }
          });
          this.$toast.error(err.response.data.message, { duration: 5000 });
        });
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
  },
};
</script>
